import script from "./SimulationHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./SimulationHeader.vue?vue&type=script&setup=true&lang=js"

import "./SimulationHeader.vue?vue&type=style&index=0&id=419fcc00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-419fcc00"]])

export default __exports__